import { Model } from '@vuex-orm/core'
import Unit from '@models/building/Unit'

export default class Building extends Model{
  static entity = 'buildings'
  static fields () {
    return {
      id: this.uid(),
      type: this.number(0),
      location: this.number(0),
      height: this.number(0),
      heatProtection: this.number(1),
      airtightness: this.number(0),
      airExchange: this.number(null).nullable(),
      pressureExponent: this.number(null).nullable(),

      controllingCombo: this.attr([{ value: 'A', text: 'A' }, { value: 'B', text: 'B' }, { value: 'C', text: 'C' }, { value: 'D', text: 'D' }, { value: 'E', text: 'E' }, { value: 'F', text: 'F' }, { value: 'G', text: 'G' }, { value: 'H', text: 'H' }, { value: 'I', text: 'I' }, { value: 'J', text: 'J' }, { value: 'K', text: 'K' }, { value: 'L', text: 'L' }, { value: 'M', text: 'M' }, { value: 'N', text: 'N' }, { value: 'O', text: 'O' }, { value: 'P', text: 'P' }, { value: 'Q', text: 'Q' }, { value: 'R', text: 'R' }, { value: 'S', text: 'S' }, { value: 'T', text: 'T' }, { value: 'U', text: 'U' }, { value: 'V', text: 'V' }, { value: 'W', text: 'W' }, { value: 'X', text: 'X' }, { value: 'Y', text: 'Y' }, { value: 'Z', text: 'Z' } ]),
    
      units: this.hasMany(Unit, 'buildingId'),
      articleStatus: this.attr('create')
    }
  }
}
  